var _effectorFileName = "/builds/gmini/front-common/src/components/FilterPanel/utils/getDependencies.ts";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import { isNotEmpty } from '@gmini/utils';
export var getDependencies = function getDependencies(dependenciesWithModels) {
  return dependenciesWithModels.map(function (_ref) {
    var classifier = _ref.classifier,
        models = _ref.models;

    if (classifier.type === 'BaseClassifier') {
      return models[0];
    }

    return classifier;
  }).filter(isNotEmpty);
};